import { AgenticHubPayload } from '@numeo/types'
import { WsMessage, WsMessageCategory } from '@numeo/types-core'
import { AppDispatch, RootState } from 'store'
import { handleAgenticHubSocketEvent } from '../../../features/agentic-hub/store/socket-handlers'
import { handleDispatchHelpSocketEvent } from '../../../features/dispatch-help'
import { handleGeneralAgentSocketEvent } from '../../../features/general-agent'

export const handleAgenticHubMessages = (message: WsMessage, dispatch: AppDispatch, getState?: () => RootState) => {
    if (message.categoryType !== WsMessageCategory.AgenticHub || !message.data) return
    try {
        const data = message.data as AgenticHubPayload
        // Forward the envelope-level eventId (used as the replay cursor) alongside the payload.
        // The handlers share the AgenticHub lane: each no-ops on events that are not its own (the general agent's
        // only reads its open chat's turn end and failure), so it's safe to call all of them for every message.
        handleAgenticHubSocketEvent(dispatch, data, message.eventId, getState)
        handleDispatchHelpSocketEvent(dispatch, data, message.eventId, getState)
        handleGeneralAgentSocketEvent(data)
    } catch (error) {
        console.error('Error handling agentic hub message:', error)
    }
}
